<nav class="navbar-category category-nav-bar p-0 ">
  <div class="container">
    @if (isCategoryNavBarVisible) {
      @for (categoryTreeItem of categoryTreeItemList; track categoryTreeItem; let first = $first; let last = $last) {
        <span class="nav-item d-flex flex-column align-items-center text-center c-pointer m-0" [class.ms-auto]="first"
          [class.me-auto]="last" [routerLink]="['/category']" [queryParams]="{ categoryKey: categoryTreeItem.key }"
          target="_top"
          [class.active-underline]="activeCategory != undefined && categoryTreeItem.key?.includes(activeCategory)"
          [class.active]="activeCategory != undefined && categoryTreeItem.key?.includes(activeCategory)">
          <span class="nav-item-text">{{ categoryTreeItem.description }}</span>
        </span>
      }
    }
  </div>
</nav>